export default class ClickableTableRow {
    #row

    constructor(element) {
        this.#row = element

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new ClickableTableRow(element))
    }

    #bindEvents() {
        this.#row.addEventListener('click', this.#handleClick)
    }

    #handleClick = (event) => {
        if (this.#row.dataset.href === undefined) {
            return false
        }

        const ignoreTags = ['a', 'button', 'input', 'textarea', 'select']
        const ignoreClasses = ['ignore-clickable']

        let clickedTagName = event.target.tagName.toLowerCase()
        let parentTagName = event.target.parentNode.tagName.toLowerCase()
        const intersectionResult = event.target.className
            .split(' ')
            .filter((x) => ignoreClasses.indexOf(x) !== -1)

        if (
            ignoreTags.includes(clickedTagName) ||
            ignoreTags.includes(parentTagName) ||
            intersectionResult.length !== 0
        ) {
            event.stopPropagation()
            return false
        }

        window.location = this.#row.dataset.href

        return false
    }
}
